import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import type { ColumnDef } from '@tanstack/react-table'
import { PlusIcon } from 'lucide-react'
import { useMemo } from 'react'

import { Cell, DataTable, useDataTable } from '@/components/block/data-table'
import { Page } from '@/components/layout/page'
import { Button } from '@/components/ui/button'
import { CardExtendTable } from '@/components/ui/card-extend'

import { uomApi } from '@/features/inventory/api/uom-api'
import type { UomDto } from '@/features/inventory/dto/uom-dto'

export const Route = createFileRoute('/_app/inventory/uom/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Page>
      <Page.Breadcrumbs />
      <UnitTable />
    </Page>
  )
}

function UnitTable() {
  const { data, isLoading } = useQuery({ ...uomApi.list.query({}) })

  const columns = useMemo(() => getColumns(), [])
  const table = useDataTable({
    columns,
    isLoading,
    data: data?.data.uoms ?? [],
  })

  return (
    <CardExtendTable
      title='Daftar Unit'
      action={
        <Button asChild>
          <Link to='/inventory/uom/create'>
            <PlusIcon /> Tambah Unit
          </Link>
        </Button>
      }
    >
      <DataTable.Root table={table}>
        <DataTable.Table />
        <DataTable.Pagination />
      </DataTable.Root>
    </CardExtendTable>
  )
}

function getColumns(): ColumnDef<UomDto>[] {
  return [
    {
      accessorKey: 'code',
      header: 'Kode',
      minSize: 180,
      cell: ({ row }) => (
        <Cell.Link
          from={Route.fullPath}
          to='/inventory/uom/update/$id'
          params={{ id: row.original.id }}
        >
          {row.original.code}
        </Cell.Link>
      ),
    },
    {
      accessorKey: 'updatedAt',
      header: () => 'Updated At',
      cell: ({ row }) => <Cell.Date date={row.original.updatedAt} />,
    },
    {
      accessorKey: 'createdAt',
      header: () => 'Created At',
      cell: ({ row }) => <Cell.Date date={row.original.createdAt} />,
    },
  ]
}
